/**
 * Selectbox
 * @class
 */
class Selectbox {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      elms: {
        txtClass: 'js-selectbox-txt',
      },
      disabledClass: 'is-disabled',
    }
  }


  /**
   * @instance
   * @param _$el {HTMLElement}
   * @param _opts {object}
   */
  constructor(_$el, _opts = {}) {
    const { elms, disabledClass } = _.defaultsDeep(_opts, Selectbox.defOpts);

    this.$el     = _$el;
    this.$txt    = this.$el.getElementsByClassName(elms.txtClass)[0];
    this.$select = this.$el.getElementsByTagName('select')[0];

    this.disabledClass = disabledClass;

    this.$select.addEventListener('change', this.onChange.bind(this), false);

    this.update();
  }

  /**
   * @instance
   * @private
   * @param _e {event}
   */
  onChange(_e) {
    let initVal_ = null;
    if(_e) {
      if(_e.detail) {
        if(_e.detail.initVal) {
          initVal_ = _e.detail.initVal;
        }
      }
    }
    this.update(initVal_);
  }

  /**
   * @instance
   * @private
   * @param _initVal {string}
   */
  update(_initVal = null) {
    const val_   = _initVal ? _initVal : this.$select.value;
    const $$opt_ = this.$select.getElementsByTagName('option');

    if(_initVal) {
      this.$select.value = _initVal;
    }

    this.$txt.innerHTML = '';

    _.forEach($$opt_, (_$opt) => {
      if(val_ === _$opt.value) {
        this.$txt.innerHTML = _$opt.textContent;
        return false;
      }
    });

    if(this.hasElement($$opt_)) {
      this.$el.classList.remove(this.disabledClass);
      this.$select.style.display = '';
    } else {
      this.$el.classList.add(this.disabledClass);
      this.$select.style.display = 'none';
    }
  }

  /**
   * @instance
   * @private
   * @param _$$el {HTMLElement}
   * @return {boolean}
   */
  hasElement(_$$el) {
    return (0 < _$$el.length) ? true : false;
  }

}

/**
 * class exports
 */
module.exports = Selectbox;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/form/selectbox.js
 **/